export const PlanFilterType = {
  ALL: "All",
  YEAR: "Year",
  SIX_MONTH: "SixMonth",
  THREE_MONTH: "ThreeMonth",
  MONTH: "Month",
};
